export const CONTACT_PHONE_DISPLAY = '438 395 0131'
export const CONTACT_PHONE_HREF = 'tel:+14383950131'
export const CONTACT_EMAIL = 'lesartisanssucres@gmail.com'
export const CONTACT_EMAIL_HREF = 'mailto:lesartisanssucres@gmail.com'

/** Pickup point in Chambly. */
export const PICKUP_ADDRESS = '1599 avenue Kent, Chambly, QC J3L 2R7'
export const PICKUP_MAP_URL =
  'https://maps.google.com/?q=1599+avenue+Kent+Chambly+QC+J3L+2R7'

/** Cities served by delivery — fee depends on the distance. */
export const DELIVERY_CITIES = [
  'Brossard',
  'Longueuil',
  'Candiac',
  'Saint-Hubert',
  'Saint-Jean-sur-Richelieu',
  'Carignan',
]

export const MINIMUM_ORDER = 50
export const ORDER_LEAD_DAYS = 3
export const FIRST_ORDER_DISCOUNT = 15

export const INSTAGRAM_URL =
  'https://www.instagram.com/chocolaterie_lesartisanssucres/'
export const INSTAGRAM_HANDLE = '@chocolaterie_lesartisanssucres'
export const FACEBOOK_URL =
  'https://www.facebook.com/profile.php?id=61591355378414'
export const TIKTOK_URL = 'https://www.tiktok.com/@chocolaterie.arte'
export const TIKTOK_HANDLE = '@chocolaterie.arte'

/**
 * Shopify storefront — store handle: chocolaterie-les-artisans-sucres.
 * Checkout, payments and taxes are handled by Shopify.
 */
/** Your purchased domain, connected to the Shopify storefront. */
/** This showcase site lives on the www subdomain. */
export const SITE_DOMAIN = 'www.lesartisanssucres.com'
export const SITE_URL = 'https://www.lesartisanssucres.com'

/**
 * The Shopify storefront. The custom domain now serves this showcase site,
 * so checkout links use the store's own Shopify address.
 */
export const SHOPIFY_STORE_URL = 'https://orrqbstb7pgkrfhb.myshopify.com'

/** Destination used by every checkout / payment button. */
export const SHOPIFY_CHECKOUT_URL = `${SHOPIFY_STORE_URL}/cart`

/** Shopify locale prefix — French is the store's default locale (no prefix). */
const SHOPIFY_LOCALE_PREFIX: Record<string, string> = {
  fr: '',
  es: '/es',
  en: '/en',
}

/**
 * Builds the storefront product URL for a Shopify product handle,
 * in the visitor's language. Falls back to the full catalogue.
 */
export function buildShopifyProductUrl(
  handle: string | undefined,
  language: string,
): string {
  const prefix = SHOPIFY_LOCALE_PREFIX[language] ?? ''
  return handle
    ? `${SHOPIFY_STORE_URL}${prefix}/products/${handle}`
    : `${SHOPIFY_STORE_URL}${prefix}/collections/all`
}

/** Storefront entry point used by the payment buttons. */
export const SHOPIFY_PREVIEW_URL = SHOPIFY_CHECKOUT_URL

export const SHOPIFY_CART_URL = SHOPIFY_CHECKOUT_URL

/** Payment methods enabled at Shopify checkout. */
export const PAYMENT_METHODS = [
  'Visa',
  'Mastercard',
  'American Express',
  'Apple Pay',
  'Google Pay',
  'Shop Pay',
]

/**
 * Every checkout button points at the configured Shopify link.
 * Once variant ids are available, this can build a cart permalink instead.
 */
export function buildShopifyCartUrl(
  _lines: { variantId?: string; quantity: number }[],
): string {
  return SHOPIFY_CHECKOUT_URL
}
